import { render, staticRenderFns } from "./AddCashback.vue?vue&type=template&id=08098597&scoped=true&"
import script from "./AddCashback.vue?vue&type=script&lang=js&"
export * from "./AddCashback.vue?vue&type=script&lang=js&"
import style0 from "./AddCashback.vue?vue&type=style&index=0&id=08098597&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08098597",
  null
  
)

export default component.exports